import { render, staticRenderFns } from "./EditEstimatePage.vue?vue&type=template&id=283b3296&scoped=true&"
import script from "./EditEstimatePage.vue?vue&type=script&lang=ts&"
export * from "./EditEstimatePage.vue?vue&type=script&lang=ts&"
import style0 from "./EditEstimatePage.vue?vue&type=style&index=0&id=283b3296&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283b3296",
  null
  
)

export default component.exports